export enum AccountType {
  Home = 'Home',
  Studio = 'Studio',
}

// todo move these to org config
export const SUSSEX_ACCOUNTID = 'acct_1CHVz6CYhDMVLM8m';
export const HOME_ACCOUNTID = 'acct_1HH8VWGgqUDgVRX6';
export const JUICEPLUS_HOME_ACCOUNTID = 'acct_1Nxp1rCsT0TSR8Tm';
export const CENTURION_ACCOUNTID = 'CENTURION_ACCOUNTID';
export const BROOKVALE_ACCOUNTID = 'acct_1M1fCPLd8sv8uhTt';
export const FB_PLATFORM_ACCOUNTID = 'acct_1HH8LdAcaWctOtVH';
export const IMMERSE_ACCOUNTID = 'acct_1OwUN6AA2YE9DeSl';
export const ACCOUNTIDS = [
  SUSSEX_ACCOUNTID,
  HOME_ACCOUNTID,
  BROOKVALE_ACCOUNTID,
  JUICEPLUS_HOME_ACCOUNTID,
  FB_PLATFORM_ACCOUNTID,
  IMMERSE_ACCOUNTID,
];
export const HOME_ACCOUNT_NO_PLAN: string = 'HOME_ACCOUNT_NO_PLAN';
const fixedPlanIdsPerAccount: {
  [key: string]: string[],
} = {};
fixedPlanIdsPerAccount[HOME_ACCOUNTID] = [HOME_ACCOUNT_NO_PLAN];
export const FixedPlanIdsPerAccount = fixedPlanIdsPerAccount;

export enum Organisation {
  JohnsonAndJohnson = 'JohnsonAndJohnson',
  JuicePlus = 'JuicePlus',
  Fitillion = 'Fitillion',
  ImmerseGymsUK = 'ImmerseGymsUK',
  FitillionPrivate = 'FitillionPrivate',
  Brookvale = 'Brookvale',
  Bidvest = 'Bidvest',
  KnightFrank = 'KnightFrank',
  GoSmartWellness = 'GoSmartWellness',
  Entelect = 'Entelect',
  Primedia= 'Primedia',
  MKWellness = 'MKWellness',
  Bryte = 'Bryte',
  GrowthPoint = 'GrowthPoint',
  Test = 'Test',
}
